<template>
    <div class="site-search d-flex align-items-center px-4 py-3">
        <input v-model="searchString" class="pr-4" type="text" placeholder="Buscar">
        <span class="icon-search text-gray"></span>
    </div>
    
</template>

<script>
    export default {
        data: function () {
            return {
                searchString: '',
            }
        },

        mounted: function () {
            //
        },

        methods: {
            //
        }
    }
</script>

<style lang="scss">
    @import "./../../sass/variables";

    .site-search{
        background-color: $white;

        input{
            flex: 1 1 auto;
            border: none;
            background: transparent;
            min-width: 8rem;

            &::placeholder{
                color: $gray;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/SiteSearch.vue